import { FC, useId } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export enum FileTypeIconKind {
  CSV = 'csv',
  DOC = 'doc',
  DOCX = 'docx',
  JPG = 'jpg',
  PDF = 'pdf',
  PNG = 'png',
  PPT = 'ppt',
  SVG = 'svg',
  TXT = 'txt',
  XLS = 'xls',
  ZIP = 'zip',
}

type FileTypeMark = {
  d: string;
  stroke: string;
  strokeWidth: number;
};

const FILE_TYPE_MARKS: Record<FileTypeIconKind, FileTypeMark[]> = {
  [FileTypeIconKind.CSV]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#1D7044',
      strokeWidth: 2,
    },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#1D7044',
      strokeWidth: 2,
    },
    {
      d: 'M7 16.5C7 16.1022 6.84196 15.7206 6.56066 15.4393C6.27936 15.158 5.89782 15 5.5 15C5.10218 15 4.72064 15.158 4.43934 15.4393C4.15804 15.7206 4 16.1022 4 16.5V19.5C4 19.8978 4.15804 20.2794 4.43934 20.5607C4.72064 20.842 5.10218 21 5.5 21C5.89782 21 6.27936 20.842 6.56066 20.5607C6.84196 20.2794 7 19.8978 7 19.5',
      stroke: '#1D7044',
      strokeWidth: 2,
    },
    {
      d: 'M10 20.25C10 20.664 10.336 21 10.75 21H12C12.2652 21 12.5196 20.8946 12.7071 20.7071C12.8946 20.5196 13 20.2652 13 20V19C13 18.7348 12.8946 18.4804 12.7071 18.2929C12.5196 18.1054 12.2652 18 12 18H11C10.7348 18 10.4804 17.8946 10.2929 17.7071C10.1054 17.5196 10 17.2652 10 17V16C10 15.7348 10.1054 15.4804 10.2929 15.2929C10.4804 15.1054 10.7348 15 11 15H12.25C12.4489 15 12.6397 15.079 12.7803 15.2197C12.921 15.3603 13 15.5511 13 15.75',
      stroke: '#1D7044',
      strokeWidth: 2,
    },
    { d: 'M16 15L18 21L20 15', stroke: '#1D7044', strokeWidth: 2 },
  ],
  [FileTypeIconKind.DOC]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    {
      d: 'M5 15V21H6C6.53043 21 7.03914 20.7893 7.41421 20.4142C7.78929 20.0391 8 19.5304 8 19V17C8 16.4696 7.78929 15.9609 7.41421 15.5858C7.03914 15.2107 6.53043 15 6 15H5Z',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    {
      d: 'M20 16.5C20 16.1022 19.842 15.7206 19.5607 15.4393C19.2794 15.158 18.8978 15 18.5 15C18.1022 15 17.7206 15.158 17.4393 15.4393C17.158 15.7206 17 16.1022 17 16.5V19.5C17 19.8978 17.158 20.2794 17.4393 20.5607C17.7206 20.842 18.1022 21 18.5 21C18.8978 21 19.2794 20.842 19.5607 20.5607C19.842 20.2794 20 19.8978 20 19.5',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    {
      d: 'M13.5607 15.4393C13.2794 15.158 12.8978 15 12.5 15C12.1022 15 11.7206 15.158 11.4393 15.4393C11.158 15.7206 11 16.1022 11 16.5V19.5C11 19.8978 11.158 20.2794 11.4393 20.5607C11.7206 20.842 12.1022 21 12.5 21C12.8978 21 13.2794 20.842 13.5607 20.5607C13.842 20.2794 14 19.8978 14 19.5V16.5C14 16.1022 13.842 15.7206 13.5607 15.4393Z',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
  ],
  [FileTypeIconKind.DOCX]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    {
      d: 'M2 15V21H3C3.53043 21 4.03914 20.7893 4.41421 20.4142C4.78929 20.0391 5 19.5304 5 19V17C5 16.4696 4.78929 15.9609 4.41421 15.5858C4.03914 15.2107 3.53043 15 3 15H2Z',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    {
      d: 'M17 16.5C17 16.1022 16.842 15.7206 16.5607 15.4393C16.2794 15.158 15.8978 15 15.5 15C15.1022 15 14.7206 15.158 14.4393 15.4393C14.158 15.7206 14 16.1022 14 16.5V19.5C14 19.8978 14.158 20.2794 14.4393 20.5607C14.7206 20.842 15.1022 21 15.5 21C15.8978 21 16.2794 20.842 16.5607 20.5607C16.842 20.2794 17 19.8978 17 19.5',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    {
      d: 'M9.5 15C9.89782 15 10.2794 15.158 10.5607 15.4393C10.842 15.7206 11 16.1022 11 16.5V19.5C11 19.8978 10.842 20.2794 10.5607 20.5607C10.2794 20.842 9.89782 21 9.5 21C9.10218 21 8.72064 20.842 8.43934 20.5607C8.15804 20.2794 8 19.8978 8 19.5V16.5C8 16.1022 8.15804 15.7206 8.43934 15.4393C8.72064 15.158 9.10218 15 9.5 15Z',
      stroke: '#1B99D8',
      strokeWidth: 2,
    },
    { d: 'M19.5 15L22.5 21', stroke: '#1B99D8', strokeWidth: 2 },
    { d: 'M19.5 21L22.5 15', stroke: '#1B99D8', strokeWidth: 2 },
  ],
  [FileTypeIconKind.JPG]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#8547E8',
      strokeWidth: 2,
    },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#8547E8',
      strokeWidth: 2,
    },
    {
      d: 'M11 18H12.5C12.8978 18 13.2794 17.842 13.5607 17.5607C13.842 17.2794 14 16.8978 14 16.5C14 16.1022 13.842 15.7206 13.5607 15.4393C13.2794 15.158 12.8978 15 12.5 15H11V21',
      stroke: '#8547E8',
      strokeWidth: 2,
    },
    {
      d: 'M20 15H19C18.4696 15 17.9609 15.2107 17.5858 15.5858C17.2107 15.9609 17 16.4696 17 17V19C17 19.5304 17.2107 20.0391 17.5858 20.4142C17.9609 20.7893 18.4696 21 19 21H20V18',
      stroke: '#8547E8',
      strokeWidth: 2,
    },
    {
      d: 'M5 15H8V19.5C8 19.8978 7.84196 20.2794 7.56066 20.5607C7.27936 20.842 6.89782 21 6.5 21C6.10218 21 5.72064 20.842 5.43934 20.5607C5.15804 20.2794 5 19.8978 5 19.5',
      stroke: '#8547E8',
      strokeWidth: 2,
    },
  ],
  [FileTypeIconKind.PDF]: [
    {
      d: 'M13.9999 3V7C13.9999 7.26522 14.1052 7.51957 14.2928 7.70711C14.4803 7.89464 14.7347 8 14.9999 8H18.9999',
      stroke: '#F04438',
      strokeWidth: 1.8,
    },
    {
      d: 'M4.99988 12V5C4.99988 4.46957 5.21059 3.96086 5.58566 3.58579C5.96074 3.21071 6.46944 3 6.99988 3H13.9999L18.9999 8V12',
      stroke: '#F04438',
      strokeWidth: 1.8,
    },
    {
      d: 'M4.99988 18H6.49988C6.8977 18 7.27923 17.842 7.56054 17.5607C7.84184 17.2794 7.99988 16.8978 7.99988 16.5C7.99988 16.1022 7.84184 15.7206 7.56054 15.4393C7.27923 15.158 6.8977 15 6.49988 15H4.99988V21',
      stroke: '#F04438',
      strokeWidth: 1.8,
    },
    { d: 'M16.9999 18H18.9999', stroke: '#F04438', strokeWidth: 1.8 },
    { d: 'M19.9999 15H16.9999V21', stroke: '#F04438', strokeWidth: 1.8 },
    {
      d: 'M10.9999 15V21H11.9999C12.5303 21 13.039 20.7893 13.4141 20.4142C13.7892 20.0391 13.9999 19.5304 13.9999 19V17C13.9999 16.4696 13.7892 15.9609 13.4141 15.5858C13.039 15.2107 12.5303 15 11.9999 15H10.9999Z',
      stroke: '#F04438',
      strokeWidth: 1.8,
    },
  ],
  [FileTypeIconKind.PNG]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#4762E8',
      strokeWidth: 2,
    },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#4762E8',
      strokeWidth: 2,
    },
    {
      d: 'M20 15H19C18.4696 15 17.9609 15.2107 17.5858 15.5858C17.2107 15.9609 17 16.4696 17 17V19C17 19.5304 17.2107 20.0391 17.5858 20.4142C17.9609 20.7893 18.4696 21 19 21H20V18',
      stroke: '#4762E8',
      strokeWidth: 2,
    },
    {
      d: 'M5 18H6.5C6.89782 18 7.27936 17.842 7.56066 17.5607C7.84196 17.2794 8 16.8978 8 16.5C8 16.1022 7.84196 15.7206 7.56066 15.4393C7.27936 15.158 6.89782 15 6.5 15H5V21',
      stroke: '#4762E8',
      strokeWidth: 2,
    },
    { d: 'M11 21V15L14 21V15', stroke: '#4762E8', strokeWidth: 2 },
  ],
  [FileTypeIconKind.PPT]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#D24726',
      strokeWidth: 2,
    },
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#D24726',
      strokeWidth: 2,
    },
    {
      d: 'M5 18H6.5C6.89782 18 7.27936 17.842 7.56066 17.5607C7.84196 17.2794 8 16.8978 8 16.5C8 16.1022 7.84196 15.7206 7.56066 15.4393C7.27936 15.158 6.89782 15 6.5 15H5V21',
      stroke: '#D24726',
      strokeWidth: 2,
    },
    {
      d: 'M11 18H12.5C12.8978 18 13.2794 17.842 13.5607 17.5607C13.842 17.2794 14 16.8978 14 16.5C14 16.1022 13.842 15.7206 13.5607 15.4393C13.2794 15.158 12.8978 15 12.5 15H11V21',
      stroke: '#D24726',
      strokeWidth: 2,
    },
    { d: 'M16.5 15H19.5', stroke: '#D24726', strokeWidth: 2 },
    { d: 'M18 15V21', stroke: '#D24726', strokeWidth: 2 },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#D24726',
      strokeWidth: 2,
    },
  ],
  [FileTypeIconKind.SVG]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#EF9F27',
      strokeWidth: 2,
    },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#EF9F27',
      strokeWidth: 2,
    },
    {
      d: 'M4 20.25C4 20.664 4.336 21 4.75 21H6C6.26522 21 6.51957 20.8946 6.70711 20.7071C6.89464 20.5196 7 20.2652 7 20V19C7 18.7348 6.89464 18.4804 6.70711 18.2929C6.51957 18.1054 6.26522 18 6 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V16C4 15.7348 4.10536 15.4804 4.29289 15.2929C4.48043 15.1054 4.73478 15 5 15H6.25C6.44891 15 6.63968 15.079 6.78033 15.2197C6.92098 15.3603 7 15.5511 7 15.75',
      stroke: '#EF9F27',
      strokeWidth: 2,
    },
    { d: 'M10 15L12 21L14 15', stroke: '#EF9F27', strokeWidth: 2 },
    {
      d: 'M20 15H19C18.4696 15 17.9609 15.2107 17.5858 15.5858C17.2107 15.9609 17 16.4696 17 17V19C17 19.5304 17.2107 20.0391 17.5858 20.4142C17.9609 20.7893 18.4696 21 19 21H20V18',
      stroke: '#EF9F27',
      strokeWidth: 2,
    },
  ],
  [FileTypeIconKind.TXT]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#344054',
      strokeWidth: 2,
    },
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#344054',
      strokeWidth: 2,
    },
    { d: 'M16.5 15H19.5', stroke: '#344054', strokeWidth: 2 },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#344054',
      strokeWidth: 2,
    },
    { d: 'M4.5 15H7.5', stroke: '#344054', strokeWidth: 2 },
    { d: 'M6 15V21', stroke: '#344054', strokeWidth: 2 },
    { d: 'M18 15V21', stroke: '#344054', strokeWidth: 2 },
    { d: 'M10 15L14 21', stroke: '#344054', strokeWidth: 2 },
    { d: 'M10 21L14 15', stroke: '#344054', strokeWidth: 2 },
  ],
  [FileTypeIconKind.XLS]: [
    {
      d: 'M13.9999 3V7C13.9999 7.26522 14.1052 7.51957 14.2928 7.70711C14.4803 7.89464 14.7347 8 14.9999 8H18.9999',
      stroke: '#039855',
      strokeWidth: 1.8,
    },
    {
      d: 'M4.99988 12V5C4.99988 4.46957 5.21059 3.96086 5.58566 3.58579C5.96074 3.21071 6.46944 3 6.99988 3H13.9999L18.9999 8V12',
      stroke: '#039855',
      strokeWidth: 1.8,
    },
    { d: 'M4.00012 15L8.00012 21', stroke: '#039855', strokeWidth: 1.8 },
    { d: 'M4.00012 21L8.00012 15', stroke: '#039855', strokeWidth: 1.8 },
    {
      d: 'M16.9999 20.25C16.9999 20.664 17.3359 21 17.7499 21H18.9999C19.2651 21 19.5194 20.8946 19.707 20.7071C19.8945 20.5196 19.9999 20.2652 19.9999 20V19C19.9999 18.7348 19.8945 18.4804 19.707 18.2929C19.5194 18.1054 19.2651 18 18.9999 18H17.9999C17.7347 18 17.4803 17.8946 17.2928 17.7071C17.1052 17.5196 16.9999 17.2652 16.9999 17V16C16.9999 15.7348 17.1052 15.4804 17.2928 15.2929C17.4803 15.1054 17.7347 15 17.9999 15H19.2499C19.4488 15 19.6396 15.079 19.7802 15.2197C19.9209 15.3603 19.9999 15.5511 19.9999 15.75',
      stroke: '#039855',
      strokeWidth: 1.8,
    },
    { d: 'M10.9999 15V21H13.9999', stroke: '#039855', strokeWidth: 1.8 },
  ],
  [FileTypeIconKind.ZIP]: [
    {
      d: 'M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19',
      stroke: '#F79009',
      strokeWidth: 2,
    },
    {
      d: 'M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12',
      stroke: '#F79009',
      strokeWidth: 2,
    },
    {
      d: 'M16 18H17.5C17.8978 18 18.2794 17.842 18.5607 17.5607C18.842 17.2794 19 16.8978 19 16.5C19 16.1022 18.842 15.7206 18.5607 15.4393C18.2794 15.158 17.8978 15 17.5 15H16V21',
      stroke: '#F79009',
      strokeWidth: 2,
    },
    { d: 'M12 15V21', stroke: '#F79009', strokeWidth: 2 },
    { d: 'M5 15H8L5 21H8', stroke: '#F79009', strokeWidth: 2 },
  ],
};

export type FileTypeIconProps = { kind: FileTypeIconKind } & IconProps;

export const FileTypeIcon: FC<FileTypeIconProps> = ({
  kind,
  className,
  width = 24,
  height = 24,
  ...props
}) => {
  const clipId = useId();

  return (
    <svg
      className={twMerge('shrink-0', className)}
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        {FILE_TYPE_MARKS[kind].map((mark, index) => (
          <path
            d={mark.d}
            key={index}
            stroke={mark.stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={mark.strokeWidth}
          />
        ))}
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect fill="white" height="24" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
};
